export enum COLORS {
  GREEN = "green",
  YELLOW = "#ffff00a1",
  GRAY = "gray",
  KEYBOARD_GRAY = "#d3d6dacf",
  WHITE = "white",
  BLACK = "black",
}
